export function isHtmlContentType(contentType: string): boolean {
  return contentType.split(";", 1)[0]?.trim().toLowerCase() === "text/html";
}

export function isGalleryContentType(contentType: string): boolean {
  return contentType.trim().toLowerCase().startsWith("image/") || isHtmlContentType(contentType);
}
